import { CommonStatusTag } from 'components/CommonStatusTag';

import { colors } from 'constants/colors';

import { OrganizationState } from 'data/__generated__';
import { ORGANIZATIONS_STATES_LABELS } from '../constants/states';

const getColorsFromState = (state: OrganizationState) => {
    switch (state) {
        case OrganizationState.Rollout:
            return { backgroundColor: colors.green, labelColor: colors.black };
        case OrganizationState.Archived:
            return { backgroundColor: colors.pantinGrey, labelColor: colors.pureWhite };
    }
};

export const StatusTag = ({ state, showHeading }: { state: OrganizationState; showHeading?: boolean }) => {
    const { backgroundColor, labelColor } = getColorsFromState(state);
    return (
        <CommonStatusTag
            backgroundColor={backgroundColor}
            labelColor={labelColor}
            label={ORGANIZATIONS_STATES_LABELS[state]}
            showHeading={showHeading}
        />
    );
};
